export default __webpack_public_path__ + "static/media/img2.531a1174.jpg";